import { render, staticRenderFns } from "./VipCard.vue?vue&type=template&id=7d4da3c2&scoped=true"
import script from "./VipCard.vue?vue&type=script&lang=js"
export * from "./VipCard.vue?vue&type=script&lang=js"
import style0 from "./VipCard.vue?vue&type=style&index=0&id=7d4da3c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4da3c2",
  null
  
)

export default component.exports